import React from 'react';
import { TextField } from '../../../../../components';
import { useField } from 'formik';
import { IHubspotField } from '../../../../../models/hubspot-forms';
import { stripHtml } from '../../../util';

interface PhoneFieldAdapterProps {
  field: IHubspotField;
}

export const PhoneFieldAdapter: React.FC<PhoneFieldAdapterProps> = ({ field }) => {
  const [formikField, meta] = useField(field.name);

  if (field.hidden) {
    return null;
  }

  // Extract validation error state
  const showError = meta.touched && Boolean(meta.error);

  return (
    <TextField
      {...formikField}
      id={field.name}
      name={field.name}
      type="tel"
      label={stripHtml(field.label) || field.name}
      required={field.required}
      error={showError}
      helperText={showError ? meta.error : ''}
      fullWidth
      margin="dense"
      InputLabelProps={{
        shrink: true
      }}
    />
  );
};
